// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stall-entry-practice.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stall-entry-practice/stall-entry-practice.js';

mount([g0]);
